export default __webpack_public_path__ + "static/media/BackgroundTataNeu.b4e58471.png";